module.exports = __webpack_public_path__ + "static/media/coronatracker.882f71dc.jpg";